import type { LastTurnRequest } from '@/stores/lastTurnRequest'
import { parseVoiceConfirmation } from '@/lib/voice/confirmation-handshake'
import { useVoiceStore } from '@/stores/voiceStore'

function responseConversationId(response: unknown): unknown {
  return response && typeof response === 'object' && 'conversationId' in response
    ? response.conversationId
    : undefined
}

function confirmationOrigin(
  id: unknown,
  fallback?: { conversationId: string },
): string | undefined {
  return typeof id === 'string' ? id : fallback?.conversationId
}

/** Shared WS/SSE parking policy: a missing or malformed fresh gate clears the previous turn. */
export function parkResponseConfirmation(
  response: unknown,
  origin?: { conversationId: string; request: LastTurnRequest },
): void {
  const raw =
    response && typeof response === 'object' && 'richContent' in response
      ? response.richContent
      : undefined
  const confirmation =
    raw && typeof raw === 'object' && 'voiceConfirmation' in raw
      ? parseVoiceConfirmation(raw.voiceConfirmation)
      : null
  if (confirmation !== null) {
    const responseConversation = responseConversationId(response)
    if (origin && responseConversation && responseConversation !== origin.conversationId) {
      useVoiceStore.getState().clearPendingConfirmation()
      return
    }
    const sourceConversationId = confirmationOrigin(responseConversation, origin)
    const action = origin?.request.options.orderExecutionAction
    useVoiceStore.getState().setPendingConfirmation({
      ...confirmation,
      ...(sourceConversationId ? { sourceConversationId } : {}),
      ...(origin && action
        ? {
            replay: {
              conversationId: origin.conversationId,
              orderExecutionAction: structuredClone(action),
            },
          }
        : {}),
    })
  } else {
    useVoiceStore.getState().clearPendingConfirmation()
  }
}
